module.exports = __webpack_public_path__ + "static/media/beepSound.1068a0ce.wav";